import { AbstractControl } from '@angular/forms';
import { distinctUntilChanged, map, Observable } from 'rxjs';

export function datePickerTimeControl(
  control: AbstractControl,
  isEnd: boolean,
): Observable<Date | null> {
  return control.valueChanges.pipe(
    map((date: Date | null) => {
      if (!date) return null;

      return new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        isEnd ? 23 : 0,
        isEnd ? 59 : 0,
        isEnd ? 59 : 0,
        isEnd ? 999 : 0,
      );
    }),
    distinctUntilChanged((a, b) =>
      !!a && !!b ? a.getTime() === b.getTime() : a === b,
    ),
  );
}
